import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import { DESKTOP_IMAGE_SIZES, MOBILE_IMAGE_SIZES } from '../constants';
import css from './TextAsset.module.scss';
import Image from '../../../components/Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SIZES = DESKTOP_IMAGE_SIZES.concat(MOBILE_IMAGE_SIZES);

var TextAsset = function TextAsset(_ref) {
  var image = _ref.image,
      imageLeft = _ref.imageLeft,
      fullWidth = _ref.fullWidth,
      title = _ref.title;
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, _defineProperty({}, css.fullWidth, fullWidth)]),
    children: [imageLeft && /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
      alt: image.alt ? image.alt : "Detail Image For ".concat(title),
      className: css.image,
      sizes: SIZES
    })), /*#__PURE__*/_jsx("div", {
      className: css.text,
      children: /*#__PURE__*/_jsx("div", {
        className: css.textOuter,
        children: /*#__PURE__*/_jsxs("div", {
          className: css.textInner,
          children: [/*#__PURE__*/_jsx("h2", {
            className: css.title,
            children: image.title
          }), /*#__PURE__*/_jsx("div", {
            className: css.description,
            children: image.description
          })]
        })
      })
    }), !imageLeft && /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
      alt: image.alt ? image.alt : "Detail Image For ".concat(title),
      className: css.image,
      sizes: SIZES
    }))]
  });
};

TextAsset.defaultProps = {
  fullWidth: false,
  imageLeft: false
};
TextAsset.propTypes = {
  fullWidth: PropTypes.bool,
  image: PropTypes.shape().isRequired,
  imageLeft: PropTypes.bool,
  title: PropTypes.string.isRequired
};
export default TextAsset;